const name = 'serviceReducer'

export const selectLocations = (state: any) => state[name].locations
export const selectLocationsFetching = (state: any) =>
  state[name].locationsFetching
export const selectLocationTargets = (state: any) => state[name].locationTargets
export const selectLocationTargetsFetching = (state: any) =>
  state[name].locationTargetsFetching
export const selectMaintenanceModeStatus = (state: any) =>
  state[name].isMaintenanceMode
export const selectProxyCheckerResult = (state: any) =>
  state[name].proxyCheckerResult
export const selectProxyCheckerLoading = (state: any) =>
  state[name].proxyCheckerLoading
export const selectProxyCheckerActivationStatus = (state: any) =>
  state[name].wasProxyCheckerActivated
